import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
export const BackButtonStyles = css `
  display: inline-flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${brand.black};
  ${fonts.brandonGrotesque.bold}
  font-size: 18px;
  line-height: 1em;
  margin: 0;
  padding: 0;
  text-decoration: underline;
  text-decoration-color: ${brand.green};
  text-transform: uppercase;
  text-underline-position: under;
  ${transition('color, text-decoration-color')};

  &:focus,
  &:hover {
    text-decoration-color: ${brand.black};
  }
`;
export const BackButtonIconStyles = css `
  display: inline-block;
  height: 13px;
  margin-right: 8px;
  width: 8px;
`;
const Container = styled(SectionWrapper) ``;
const Top = styled.div `
  background: ${brand.beige};
  scroll-margin: var(--headerScrollHeight) 0 0;

  @media ${until(Device.Tablet)} {
    margin-left: calc(var(--sitePadding) * -1);
    margin-right: calc(var(--sitePadding) * -1);
  }
`;
const Main = styled.div `
  scroll-margin: var(--headerScrollHeight) 0 0;

  @media ${until(Device.Tablet)} {
    display: block;
  }

  @media ${from(Device.Tablet)} {
    display: grid;
    grid-template-columns: max(25%, 438px) 1fr;
    height: calc(95vh - var(--headerHeight) - 115px);
  }
`;
const MainLeft = styled.div `
  @media ${from(Device.Tablet)} {
    ${scrollbars};

    overflow: auto;
  }
`;
const MainRight = styled.div `
  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const LocationMapStyles = {
    Container,
    Main,
    MainLeft,
    MainRight,
    Top,
};
export default LocationMapStyles;
